export default function RentalConditions() {
  return (
    <div className="container py-4">
      {/* HEADER */}
      <div className="mb-4">
        <h2 className="fw-bold text-center">Conditions de location</h2>
        <p className="text-muted text-center mb-0">
          Informations essentielles pour louer un véhicule sur MooviCar
        </p>
      </div>

      {/* INTRO */}
      <div className="alert alert-info">
        Pour louer un véhicule sur <strong>MooviCar</strong>, certaines conditions doivent être
        respectées afin que votre location soit couverte par l’assurance.
      </div>

      {/* CONDITIONS GENERALES */}
      <section className="mb-4 p-3 border rounded bg-white shadow-sm">
        <h4 className="fw-semibold mb-3">Conditions générales</h4>

        <ul className="mb-0">
          <li className="mb-2">
            Posséder un permis de conduire valide dans le pays de location
            <strong> (document original uniquement)</strong>.
          </li>
          <li className="mb-2">
            Respecter les conditions d’âge et d’ancienneté du permis selon la catégorie du véhicule.
          </li>
          <li>Régler la location avec une carte bancaire à votre nom.</li>
        </ul>
      </section>

      {/* ASSURANCE */}
      <section className="mb-4 p-3 border rounded bg-white shadow-sm">
        <h4 className="fw-semibold mb-3">Couverture d’assurance</h4>

        <ul className="mb-0">
          <li className="mb-2">Circuler uniquement dans les pays autorisés.</li>
          <li className="mb-2">Être présent lors des états des lieux de début et de fin.</li>
          <li>
            Le transport commercial de personnes est interdit. Le covoiturage avec partage des frais
            est autorisé.
          </li>
        </ul>
      </section>

      {/* VERIFICATION */}
      <section className="mb-4 p-3 border rounded bg-white shadow-sm">
        <h4 className="fw-semibold mb-3">Vérification du profil</h4>
        <p className="mb-0">
          Pour certaines catégories de véhicules ou voitures connectées, la vérification de votre
          profil peut être exigée avant le début de la location.
        </p>
      </section>

      {/* CATEGORIES */}
      <section className="mb-4 p-3 border rounded bg-white shadow-sm">
        <h4 className="fw-semibold mb-3">Conditions par catégorie de véhicule</h4>

        <div className="table-responsive">
          <table className="table table-bordered align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>Catégorie</th>
                <th>Ancienneté minimale du permis (France)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Éco</td>
                <td>2 ans</td>
              </tr>
              <tr>
                <td>Confort</td>
                <td>5 ans</td>
              </tr>
              <tr>
                <td>Privilège / Premium</td>
                <td>7 ans</td>
              </tr>
              <tr>
                <td>Prestige</td>
                <td>10 ans + location sans incident</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* AUTRES PAYS */}
      <section className="mb-4 p-3 border rounded bg-white shadow-sm">
        <h4 className="fw-semibold mb-3">Véhicules immatriculés hors France</h4>
        <ul className="mb-0">
          <li className="mb-2">Éco : minimum 21 ans et 2 ans de permis</li>
          <li className="mb-2">Confort : minimum 25 ans et 2 ans de permis</li>
          <li>Privilège : minimum 28 ans et 3 ans de permis</li>
        </ul>
      </section>

      {/* JEUNES CONDUCTEURS */}
      <section className="mb-4 p-3 border rounded bg-white shadow-sm">
        <h4 className="fw-semibold mb-3">Supplément jeune conducteur</h4>

        <ul>
          <li>18–23 ans : supplément appliqué</li>
          <li>24–25 ans : supplément réduit</li>
        </ul>

        <div className="alert alert-warning mb-0">
          Le montant exact sera affiché au moment du paiement.
        </div>
      </section>

      {/* DOCUMENTS */}
      <section className="mb-4 p-3 border rounded bg-white shadow-sm">
        <h4 className="fw-semibold mb-3">Documents requis</h4>
        <ul className="mb-0">
          <li className="mb-2">Permis de conduire original validé sur MooviCar.</li>
          <li>Présentation obligatoire du permis original lors de la remise des clés.</li>
        </ul>
      </section>

      {/* INTERDICTIONS */}
      <div className="alert alert-danger">
        Les déclarations de perte, attestations temporaires ou copies de permis ne sont pas
        acceptées. Sans le permis original, la location ne pourra pas débuter.
      </div>

      {/* FOOTER */}
      <p className="text-muted small text-center mt-3">
        Certaines règles peuvent varier selon le pays d’immatriculation du véhicule.
      </p>
    </div>
  );
}
